import { type PropsWithChildren } from 'react';

import type { BehaviorTrackingProps } from '../../core/types/behavior-tracking-props.js';
import { DataTestId } from '../../core/types/data-props.js';
import { StylingProps } from '../../core/types/styling-props.js';

//#region Typings
/**
 * Accepted properties for the Select Prefix
 * @public
 */
export type SelectPrefixProps = PropsWithChildren<unknown> &
  StylingProps &
  DataTestId &
  BehaviorTrackingProps;
//#endregion

/**
 * The `Select.Prefix` component allows you to specify any content, that should
 * be prefixed in the trigger element. The `Select.Prefix` component is only valid
 * within the `Select.Trigger` and `Select.Option` element.
 * @example
 * ```tsx
 * <Select.DisplayValue>
 *   <Select.Prefix>
 *     <WhatsNewIcon />
 *   </Select.Prefix>
 * </Select.DisplayValue>
 * ```
 * @public
 */
export function SelectPrefix(props: SelectPrefixProps): null {
  return null;
}
